export class ActivitiesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getActivitiesByApplicationId({ applicationId, types, signal }) {
    return this.#http.get(`/application/${applicationId}/activity`, {
      params: { types },
      paramsSerializer: { indexes: true },
      signal,
    });
  }
}
